import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

type PropertyTypeRegistryEntry = {
	editRoute: (propertyId: number) => string;
};

export const propertyTypeRegistry: Partial<
	Record<ClientPropertyTypeEnum, PropertyTypeRegistryEntry>
> = {
	[ClientPropertyTypeEnum.AutoMoto]: {
		editRoute: (propertyId) =>
			Routing.Portfolio.PortfolioEditCar.path(propertyId),
	},
	[ClientPropertyTypeEnum.Art]: {
		editRoute: (propertyId) =>
			Routing.Portfolio.PortfolioEditArt.path(propertyId),
	},
	[ClientPropertyTypeEnum.Land]: {
		editRoute: (propertyId) =>
			Routing.Portfolio.PortfolioEditLand.path(propertyId),
	},
	[ClientPropertyTypeEnum.Flat]: {
		editRoute: (propertyId) =>
			Routing.Portfolio.PortfolioEditRealEstate.path(propertyId),
	},
	[ClientPropertyTypeEnum.House]: {
		editRoute: (propertyId) =>
			Routing.Portfolio.PortfolioEditRealEstate.path(propertyId),
	},
	[ClientPropertyTypeEnum.Cottage]: {
		editRoute: (propertyId) =>
			Routing.Portfolio.PortfolioEditRealEstate.path(propertyId),
	},
};
